<template>
  <div
    class="flex w-full items-center justify-between bg-secondary-purple-1 px-8 py-2.5 text-xs"
    data-cy="test-mode-banner"
  >
    <div class="space-x-1.5">
      <icon-base :icon="IconSandbox" color="white" />
      <span class="text-styles">
        {{ $t("DEALS.MODE.TEST_DEAL") }}
      </span>
    </div>
    <span
      v-if="canChangeMode"
      class="text-styles cursor-pointer"
      data-cy="test-mode-banner-button"
      @click="moveDealToLive"
    >
      {{ $t("DEALS.MODE.MOVE_TO_LIVE") }}
    </span>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { DEAL_MODE_LIVE_KEY } from "@/helpers/constants";
import { useAuth } from "@/hooks/auth";

import IconSandbox from "@/components/icons/IconSandbox.vue";

const props = defineProps({
  dealId: {
    type: String,
  },
});

const { dispatch } = useStore();
const { isLendflowUser, isClientAdmin, isClientUnderwriter } = useAuth();

const canChangeMode = computed(
  () => isLendflowUser || isClientAdmin || isClientUnderwriter
);

const moveDealToLive = () => {
  dispatch("applications/updateApplicationDealMode", {
    id: props.dealId,
    deal_mode: DEAL_MODE_LIVE_KEY,
  });
};
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.text-styles {
  @apply font-medium text-white;
}
</style>
